module.exports = __webpack_public_path__ + "static/media/m-detox.5dfe07c7.pdf";